import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=f5b64b88&"
import script from "./GameList.vue?vue&type=script&lang=ts&"
export * from "./GameList.vue?vue&type=script&lang=ts&"
import style0 from "./GameList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports